import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App.jsx';
import { arrancarMedicion } from './lib/medicion.js';
import './estilos/global.css';

// Antes de montar React, y mirando la ruta del documento: la decisión de medir
// o no se toma una sola vez y no se revisa nunca más. De eso depende que las
// páginas de reserva de los negocios no carguen nada. Ver lib/medicion.js.
//
// El try/catch no es por prolijo. Esto corre ANTES del createRoot de abajo: si
// tira —un localStorage prohibido por política, un document.head raro, lo que
// sea— el módulo entero aborta, render() no llega a correr y queda una página
// en blanco sin un solo mensaje. Y pasaría sólo en /registro, que es la única
// pantalla a la que llega la plata de la campaña. Medir es lo accesorio; la
// aplicación tiene que arrancar igual.
try {
  arrancarMedicion();
} catch { /* sin medición, pero con app */ }

createRoot(document.getElementById('raiz')).render(
  <StrictMode>
    <App />
  </StrictMode>
);
